import Axios from "axios"
import Button from "consumer/custom/button"
import commonStyle from "../../custom/common.module.css";
import textStyle from "../../custom/text.module.css"


export default function Enroll(props) {

    const gradeOption = props['gradeOption']
    const verifyCheck = props['verifyCheck']
    const enrollCheck = props['enrollCheck']
    const Set_enrollCheck = props['Set_enrollCheck']
    const onlyEnrolled = props['onlyEnrolled']

    async function check_enroll() {
        if(enrollCheck) {
            alert('이미 확인되었습니다.')
        }
        else {
            const step3 = document.getElementById('step3')

            const code = step3.querySelector('[name="branch_id"]').value
            const student_name = step3.querySelector('[name="student_name"]').value
            const parent_phone = step3.querySelector('[name="parent_phone"]').value

            if(student_name.trim() === '') {
                alert('학생 이름을 입력해 주세요.')
            }
            else if(parent_phone.trim() === '') {
                alert('보호자 연락처를 입력해 주세요.')
            }
            else if(!verifyCheck) {
                alert('문자 인증이 필요합니다.')
            }
            else if(window.confirm('해당 학원에 등록된 학생 이름과 보호자 연락처가 일치해야 합니다.\n확인하시겠습니까?')) {
                const result = await Axios
                                .post("/consumer/enroll", {
                                    branch_id: code,
                                    student_name: student_name,
                                    parent_phone: parent_phone
                                })
                const data = result['data']

                alert(data['message'])
                if(data['status'] === 'success') {
                    const student_sex = data['data']['SexYN']
                    const grade = data['data']['MGradeCode'].trim()
                    const address = data['data']['Addr1']

                    step3.querySelector(`[name="student_sex"][value="${student_sex}"]:not([category="field"])`).checked = true
                    document.querySelector('[name="student_sex"][category="field"]').value = student_sex

                    const c = await gradeOption.find(x => x['value'].trim() === grade)
                    if(c) {
                        step3.querySelector(`[name="student_grade"]:not([category="field"])`).value = grade
                        document.querySelector('[name="student_grade"][category="field"]').value = grade
                    }
                    else {
                        step3.querySelector(`[name="student_grade"]:not([category="field"])`).value = ''
                        document.querySelector('[name="student_grade"][category="field"]').value = ''
                    }

                    step3.querySelector('[name="address"]').value = address

                    Set_enrollCheck(1)
                }
            }
        }
    }

    return(
        <div className={commonStyle['wrap']}>
            <input
                type="text"
                category="field"
                name="only_enrolled"
                required={onlyEnrolled}
                value={enrollCheck === 1 ? '1' : ''}
                readOnly={true}
                error="재원생 인증이 필요합니다."
                style={{
                    display: "none"
                }}
            ></input>

            <label
                className={onlyEnrolled === true ? commonStyle['required'] : null}
            >재원 여부 확인</label>

            <div
                style={{
                    display: "flex",
                    width: "100%"
                }}
            >
                <div
                    className={commonStyle['field']}
                    style={{
                        borderTopRightRadius: "0px",
                        borderBottomRightRadius: "0px"
                    }}
                >
                    <input
                        type="text"
                        className={textStyle['text']}
                        disabled={true}
                        value={enrollCheck ? '확인되었습니다.' : ''}
                    ></input>
                </div>

                <Button
                    text='확인'
                    style={{
                        backgroundColor: "#4b4b4b",
                        fontSize: "15px",
                        borderTopLeftRadius: "0px",
                        borderBottomLeftRadius: "0px",
                    }}
                    event={{
                        onClick: function() {
                            check_enroll()
                        }
                    }}
                ></Button>
            </div>
        </div>
    )
}